import { Component, Inject, Input, OnInit } from '@angular/core';
import { MENU } from '../../../core/constants/menu';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    CommonModule,
    RouterModule
  ],
  standalone: true
})
export class HeaderComponent implements OnInit {
  menu = MENU;
  optionSelected: number = 0;
  @Input() showFooter: boolean = false;
  @Input() scrolled: boolean = false;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }

  goTo(url: string, index: number) {
    this.optionSelected = index + 1;
    if (url.includes('https')) {
      window.open(url, '_blank');
    }else{
      this.router.navigateByUrl(url);
    }
  }

  menuOpen = false;

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

}
